import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import Banner from '../components/Banner'

import seoPic from '../assets/images/elev8_seo.jpg'
import socialPic from '../assets/images/social.jpg'
import webPic from '../assets/images/elev8_web_design.png'
import eCommercePic from '../assets/images/eCommerce.jpg'
import cloudPic from '../assets/images/cloud.jpg'
import digitalPic from '../assets/images/digital.jpg'
import designPic from '../assets/images/design.jpg'

class HomeIndex extends React.Component {
    render() {
        const siteTitle = this.props.data.site.siteMetadata.title
        const siteDescription = this.props.data.site.siteMetadata.description

        return (
            <div>
                <Helmet>
                    <title>{siteTitle}</title>
                    <meta name="description" content={siteDescription} />
                </Helmet>

                <Banner />

                <div id="main">
                    <section id="one" className="tiles">
                        <article style={{backgroundImage: `url(${designPic})`}}>
                            <header className="major">
                                <h3>Web Design & Development</h3>
                                <p>We build websites & experiences that perfectly communicate your business vision.</p>
                            </header>
                            <Link to="/design" className="link primary"></Link>
                        </article>
                        <article style={{backgroundImage: `url(${socialPic})`}}>
                            <header className="major">
                                <h3>Social Media Management</h3>
                                <p>We manage your social media presence professionally, so you gain exposure and generate sales.</p>
                            </header>
                            <Link to="/social" className="link primary"></Link>
                        </article>
                        <article style={{backgroundImage: `url(${seoPic})`}}>
                            <header className="major">
                                <h3>Search Engine Optimization</h3>
                                <p>Get high-conversion leads for your business.</p>
                            </header>
                            <Link to="/seo" className="link primary"></Link>
                        </article>
                        <article style={{backgroundImage: `url(${eCommercePic})`}}>
                            <header className="major">
                                <h3>eCommerce Solutions</h3>
                                <p>We help you sell your products and services online.</p>
                            </header>
                            <Link to="/eCommerce" className="link primary"></Link>
                        </article>
                        <article style={{backgroundImage: `url(${cloudPic})`}}>
                            <header className="major">
                                <h3>Application Development</h3>
                                <p>We develop solutions that just work.</p>
                            </header>
                            <Link to="/development" className="link primary"></Link>
                        </article>
                        <article style={{backgroundImage: `url(${digitalPic})`}}>
                            <header className="major">
                                <h3>Digital Consulting</h3>
                                <p>We help your business make the right decisions.</p>
                            </header>
                            <Link to="/consulting" className="link primary"></Link>
                        </article>
                    </section>
                    <section id="two">
                        <div className="inner">
                            <header className="major">
                                <h2>About</h2>
                            </header>
                            <p>We are a full-service digital marketing agency providing SEO services, social media management, PPC, web design, and creative solutions that boost your business! We develop websites, social media campaigns, and brands from scratch.</p>
<p>There are lots of ways to get yourself online nowadays with lots of talented people looking to help you out. We like to think we at elev8.it are different. If you’re looking for a partner that offers a full range of digital marketing services that helps your brand grow online, lets you take control of your marketing efforts, and improves your conversion rate, you’ve come to the right place.</p>
<p>We take care of all your digital marketing needs while you focus on what you do best – adding value through your business. We meet your technological, advertising, and online marketing needs by creating and maintaining web design, marketing, and digital identity solutions that work for your business. We are there for you long after your website is up and running in order to make sure our creative and cost-effective solutions work for your target market and bring you profitable leads.</p>
                            <ul className="actions">
                                <li><Link to="/portfolio" className="button">Portfolio</Link></li>
                                <li><Link to="/team" className="button special">Team</Link></li>
                            </ul>
                        </div>
                    </section>
                </div>

            </div>
        )
    }
}

export default HomeIndex

export const pageQuery = graphql`
    query PageQuery {
        site {
            siteMetadata {
                title
                description
            }
        }
    }
`


// WEBPACK FOOTER //
// ./src/pages/index.js